import React from 'react'
import { Moon, Sun } from "lucide-react"

import { Button } from "@/components/ui/button"
import { useTheme } from "@/components/theme-provider"
import LiquidGlassEffect from '@/pages/utils/LiquidGlassEffect'

export function ModeToggle() {
  const { setTheme } = useTheme()

  const toLight = () => {
    setTheme("light")
  };

  const toDark = () => {
    setTheme("dark")
  };

  return (
    <div>
      <Button
        id="btn-one-glass"
        variant="outline"
        size="icon"
        onClick={toDark}
        className='dark:hidden rounded-2xl bg-transparet'
        >
      <Sun className="h-5 w-5 dark:hidden" />
    </Button>
    <Button
        id="btn-twoo-glass"
        variant="outline"
        size="icon"
        onClick={toLight}
        className='hidden dark:flex items-center justify-center rounded-2xl bg-transparet border-none'
        >
      <Moon className="hidden h-5 w-5 dark:block" />
    </Button>
    <LiquidGlassEffect targetSelector="#btn-one-glass" width={200} height={64} />
    <LiquidGlassEffect targetSelector="#btn-two-glass" width={200} height={64} />
    </div>
  )
}